"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { MapPin, Phone, Mail, Facebook, Youtube, Globe, Map } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="212479" className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/80 transition-colors hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const services = ["Hệ Thống Tài Chính Mỹ", "Xây Dựng Tín Dụng", "Bay Về Việt Nam", "Tài Nguyên Cộng Đồng"];
  return <section id="footer" className="dark bg-background text-foreground py-12 lg:py-16 font-default border-t border-primary/20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          {}
          <div className="space-y-6">
            <Link to="/" className="inline-block">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1630241/img/thanhhoahdnd_logo_footer.png" alt="Vietomy Logo" className="h-7 w-auto" />
            </Link>
            <div className="space-y-4 text-sm text-foreground/70">
              <div className="flex items-start gap-3">
                <MapPin className="mt-0.5 size-4 shrink-0 text-primary" />
                <span>Hoa Kỳ & Việt Nam</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-primary" />
                <span>Tư vấn tài chính gia đình</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary" />
                <span>contact@vietomy.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-default text-lg font-semibold text-primary">Liên Kết Quan Trọng</h3>
            <MenuProvider menu_id="45">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-default text-lg font-semibold text-primary">Con Đường Học</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-sm text-foreground/80 transition-colors hover:text-primary">
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="space-y-6">
            <h3 className="font-default text-lg font-semibold text-primary">Kết Nối Với Vietomy</h3>
            <div className="flex flex-wrap gap-2">
              <Button variant="outline" size="icon" className="border-primary/30 bg-transparent hover:bg-primary hover:text-primary-foreground text-primary">
                <Facebook className="size-4" />
                <span className="sr-only">Facebook</span>
              </Button>
              <Button variant="outline" size="icon" className="border-primary/30 bg-transparent hover:bg-primary hover:text-primary-foreground text-primary">
                <Youtube className="size-4" />
                <span className="sr-only">YouTube</span>
              </Button>
              <Button variant="outline" size="icon" className="border-primary/30 bg-transparent hover:bg-primary hover:text-primary-foreground text-primary">
                <Globe className="size-4" />
                <span className="sr-only">Website</span>
              </Button>
            </div>
            <div className="pt-2">
              <Button variant="secondary" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90">
                <Map className="mr-2 size-4" />
                Tìm Hiểu Lộ Trình
              </Button>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-primary/10" />

        {}
        <div className="flex flex-col items-center justify-between gap-4 text-center text-sm text-foreground/60 md:flex-row md:text-left">
          <p>
            &copy; 2026 Vietomy. Trung Tín Tài Chính, Hưng Thịnh Gia Đình.
          </p>
          <p>
            <span className="font-medium text-foreground/80">Trong Ơn Trên.</span>
          </p>
        </div>
      </div>
    </section>;
}